/*
 * Approved copy constants for the Governance Tile header row.
 *
 * Every string exported from this file is operator-approved via
 * mockup v8.8.12 · [COPY-APPROVED: governance-tile-v8] (2026-07-24).
 *
 * No string may be edited or added without a fresh operator token.
 * The Copy Ledger and the pre-push new_ui_copy_judge (gate #8) both
 * read this file to verify no drift.
 */

export const H1_TITLE = 'How the';
export const H1_TITLE_ACCENT = 'team';
export const H1_SESSION_SUFFIX = 'is going · This Session';

export const SESSION_PREFACE =
  'Two purposes: (1) recursive memory and learning for both E1 and the Judge across sessions — every task, wrong or skipped or clean, feeds back into both agents\u2019 memory so mistakes do not recur · (2) Operator (Admin) oversees progress over time and actions Sev 0 to 3 defects. Every term on this page carries a plain-English hover tooltip you can dismiss with \u201cGot it\u201d.';

export const ZERO_COUNTER_1_LABEL =
  'artefacts of any kind made public that did not get Operator approval first.';

export const ZERO_COUNTER_2_LABEL =
  'All App end points and access to post login pages is 100% secure from public access (unless through login).';

export const VIEW_TOGGLE_ARIA = 'Time-window view selector';

export const VIEW_BUTTON_SESSION = 'Session';
export const VIEW_BUTTON_WEEKLY = 'Weekly';
export const VIEW_BUTTON_MONTHLY = 'Monthly';
export const VIEW_BUTTON_YEARLY = 'Yearly';

export const VIEW_TOGGLE_NOTE =
  'The tile stays on across sessions. When a session closes, its numbers are saved to history. When a new session opens, Session-view counters reset to zero and Weekly / Monthly / Yearly views absorb the increment.';

export const WEEKLY_PANE_HEADER = 'Weekly aggregated view';
export const MONTHLY_PANE_HEADER = 'Monthly aggregated view';
export const YEARLY_PANE_HEADER = 'Yearly aggregated view';

export const WEEKLY_PANE_STUB =
  'stub · will populate once Intent Ledger entry 079 wires the counter service · sessions accumulated this week: 0';
export const MONTHLY_PANE_STUB =
  'stub · will populate once Intent Ledger entry 079 wires the counter service · sessions accumulated this month: 0';
export const YEARLY_PANE_STUB =
  'stub · will populate once Intent Ledger entry 079 wires the counter service · sessions accumulated this year: 0';

export const WEEKLY_PANE_SHAPE =
  'Layout mirrors the Session view: same five scorecards (numbers-reconcile · E1 column · Judge column · Operator column · Direction-of-travel chart) but every counter sums across the last seven rolling days.';
export const MONTHLY_PANE_SHAPE =
  'Layout mirrors the Session view: same five scorecards but every counter sums across the last thirty rolling days.';
export const YEARLY_PANE_SHAPE =
  'Layout mirrors the Session view: same five scorecards but every counter sums across the last three hundred and sixty five rolling days.';
